export const items = [
    {
        id: 0,
        title: "Littérature. Le romancier italien, Paolo Giordano, publie en accès libre Contagions, un manisfeste sur la pandémie qui nous touche aujourd’hui",
        genre: 'philosophie',
        tags: ['amour', 'sex'],
        date: '10 Février 2020',
        auteur: 'Tiavina Michael',
        image: `image01.jpg`,
        content: [
            {
                blockTitle: `Some title here`,
                text: `But I must explain to you how 
                all this mistaken idea of denouncing pleasure and praising pain was born 
                and I will give you a complete account of the system, and expound the actual teachings of the great explorer of the truth, 
                the master-builder of human happiness. No one rejects, dislikes, or avoids pleasure itself, because it is pleasure, but because 
                those who do not know how to pursue pleasure rationally encounter consequences that are extremely painful. Nor again is there anyone who loves 
                or pursues or desires to obtain pain of itself, because it is pain, but because occasionally circumstances occur in which toil and pain can 
                procure him some great pleasure. To take a trivial example, which of us ever undertakes laborious physical exercise, except to obtain some 
                advantage from it? But who has any right to find fault with a man who chooses to enjoy a pleasure that has no annoying consequences, or one 
                who avoids a pain that produces no resultant pleasure?`,
                blockImage: { 
                    name: `image01.jpg`,
                    legend: 'But who has any right to find fault with a man '
                }
            },
            {
                blockTitle: `Some title here all this mistaken idea of denouncing `,
                text: `But I must explain to you how 
                all this mistaken idea of denouncing pleasure and praising pain was born 
                and I will give you a complete account of the system, and expound the actual teachings of the great explorer of the truth, 
                the master-builder of human happiness. No one rejects, dislikes, or avoids pleasure itself, because it is pleasure, but because 
                those who do not know how to pursue pleasure rationally encounter consequences that are extremely painful. Nor again is there anyone who loves 
                or pursues or desires to obtain pain of itself, because it is pain, but because occasionally circumstances occur in which toil and pain can 
                procure him some great pleasure. To take a trivial example, which of us ever undertakes laborious physical exercise, except to obtain some 
                advantage from it? But who has any right to find fault with a man who chooses to enjoy a pleasure that has no annoying consequences, or one 
                who avoids a pain that produces no resultant pleasure?`,
                blockImage: { 
                    name: `image01.jpg`,
                    legend: 'But who has any right to find fault with a man '
                }
            },
        ]
    },
    {
        id: 1,
        title: "2 Littérature. Le romancier italien, Paolo Giordano, publie en accès libre Contagions, un manisfeste sur la pandémie qui nous touche aujourd’hui",
        genre: 'littérature',
        tags: ['amour', 'sex'],
        date: '10 Février 2020',
        auteur: 'Tiavina Michael',
        image: `image01.jpg`,
        content: [
            {
                blockTitle: `Some title here`,
                text: `But I must explain to you how 
                all this mistaken idea of denouncing pleasure and praising pain was born 
                and I will give you a complete account of the system, and expound the actual teachings of the great explorer of the truth, 
                the master-builder of human happiness. No one rejects, dislikes, or avoids pleasure itself, because it is pleasure, but because 
                those who do not know how to pursue pleasure rationally encounter consequences that are extremely painful. Nor again is there anyone who loves 
                or pursues or desires to obtain pain of itself, because it is pain, but because occasionally circumstances occur in which toil and pain can 
                procure him some great pleasure. To take a trivial example, which of us ever undertakes laborious physical exercise, except to obtain some 
                advantage from it? But who has any right to find fault with a man who chooses to enjoy a pleasure that has no annoying consequences, or one 
                who avoids a pain that produces no resultant pleasure?`,
                blockImage: { 
                    name: `image01.jpg`,
                    legend: 'But who has any right to find fault with a man '
                }
            },
            {
                blockTitle: `Some title here all this mistaken idea of denouncing `,
                text: `But I must explain to you how 
                all this mistaken idea of denouncing pleasure and praising pain was born 
                and I will give you a complete account of the system, and expound the actual teachings of the great explorer of the truth, 
                the master-builder of human happiness. No one rejects, dislikes, or avoids pleasure itself, because it is pleasure, but because 
                those who do not know how to pursue pleasure rationally encounter consequences that are extremely painful. Nor again is there anyone who loves 
                or pursues or desires to obtain pain of itself, because it is pain, but because occasionally circumstances occur in which toil and pain can 
                procure him some great pleasure. To take a trivial example, which of us ever undertakes laborious physical exercise, except to obtain some 
                advantage from it? But who has any right to find fault with a man who chooses to enjoy a pleasure that has no annoying consequences, or one 
                who avoids a pain that produces no resultant pleasure?`,
                blockImage: { 
                    name: `image01.jpg`,
                    legend: 'But who has any right to find fault with a man '
                }
            },
        ]
    },
    {
        id: 3,
        title: "3 Littérature. Le romancier italien, Paolo Giordano, publie en accès libre Contagions, un manisfeste sur la pandémie qui nous touche aujourd’hui",
        genre: 'philosophie',
        tags: ['amour', 'sex'],
        date: '10 Février 2020',
        auteur: 'Tiavina Michael',
        image: `image01.jpg`,
        content: [
            {
                blockTitle: `Some title here`,
                text: `But I must explain to you how 
                all this mistaken idea of denouncing pleasure and praising pain was born 
                and I will give you a complete account of the system, and expound the actual teachings of the great explorer of the truth, 
                the master-builder of human happiness. No one rejects, dislikes, or avoids pleasure itself, because it is pleasure, but because 
                those who do not know how to pursue pleasure rationally encounter consequences that are extremely painful. Nor again is there anyone who loves 
                or pursues or desires to obtain pain of itself, because it is pain, but because occasionally circumstances occur in which toil and pain can 
                procure him some great pleasure. To take a trivial example, which of us ever undertakes laborious physical exercise, except to obtain some 
                advantage from it? But who has any right to find fault with a man who chooses to enjoy a pleasure that has no annoying consequences, or one 
                who avoids a pain that produces no resultant pleasure?`,
                blockImage: { 
                    name: `image01.jpg`,
                    legend: 'But who has any right to find fault with a man '
                }
            },
            {
                blockTitle: `Some title here all this mistaken idea of denouncing `,
                text: `But I must explain to you how 
                all this mistaken idea of denouncing pleasure and praising pain was born 
                and I will give you a complete account of the system, and expound the actual teachings of the great explorer of the truth, 
                the master-builder of human happiness. No one rejects, dislikes, or avoids pleasure itself, because it is pleasure, but because 
                those who do not know how to pursue pleasure rationally encounter consequences that are extremely painful. Nor again is there anyone who loves 
                or pursues or desires to obtain pain of itself, because it is pain, but because occasionally circumstances occur in which toil and pain can 
                procure him some great pleasure. To take a trivial example, which of us ever undertakes laborious physical exercise, except to obtain some 
                advantage from it? But who has any right to find fault with a man who chooses to enjoy a pleasure that has no annoying consequences, or one 
                who avoids a pain that produces no resultant pleasure?`,
                blockImage: { 
                    name: `image01.jpg`,
                    legend: 'But who has any right to find fault with a man '
                }
            },
        ]
    },
 
];